module.exports = __webpack_public_path__ + "static/media/mosque.2f67a39f.jpg";